export default __webpack_public_path__ + "static/media/eb-blk-4.145febb6.png";